import { get, some, chain } from "lodash"
import { Model } from "resources/models"
import { Portfolio } from "resources/portfolios"

export function getMostUsedOrDefaultModelId(portfolios: Portfolio[], models: Model[]): string | null {
  if (portfolios && portfolios.length > 0) {
    const mostUsedModelId = chain(portfolios)
      .countBy(portfolio => portfolio.modelId)
      .toPairs()
      .orderBy(count => count[1], "desc")
      .first()
      .first()
      .value() as string

    // If the user ever loses access to the most used model
    if (some(models, model => model.id === mostUsedModelId)) {
      return mostUsedModelId
    }
  }

  return get(models, "0.id", null)
}
